import React from "react";
import * as dates from '@simplybenefits/sb-dates';
import Text from '../../components/Text.js';
import { colors } from '../../theme/index.js';
import { Link } from "react-router-dom";
import Avatar from 'react-avatar';
import { styled } from '@mui/system';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const CardBlock = styled("div")(({
  theme
}) => ({
  '&:hover': {
    borderLeft: `${theme.palette.primary.main} solid 5px`
  },
  backgroundColor: colors.surface,
  borderLeft: `${colors.surface} solid 5px`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  marginBottom: '8px',
  minHeight: '90px',
  padding: '20px 30px 2px 25px',
  position: 'relative',
  zIndex: 4
}));
const CardBlockBottom = styled("div")(({
  theme
}) => ({
  display: 'flex',
  height: 'auto',
  minHeight: '20px',
  paddingTop: '5px',
  width: '100%',
  [theme.breakpoints.down('500')]: {
    justifyContent: 'space-between'
  }
}));
const CardBlockLeft = styled("div")(({
  theme
}) => ({
  display: 'flex',
  height: '100%',
  lineHeight: '30px',
  textAlign: 'left',
  verticalAlign: 'middle',
  width: '70%',
  [theme.breakpoints.down('500')]: {
    width: 'unset'
  }
}));
const CardBlockRight = styled("div")(({
  theme
}) => ({
  display: 'inline',
  height: '100%',
  lineHeight: '30px',
  textAlign: 'right',
  verticalAlign: 'middle',
  width: '30%',
  [theme.breakpoints.down('500')]: {
    width: '100%'
  }
}));
const CardBlockTop = styled("div")(({
  theme
}) => ({
  borderBottom: `1px solid ${colors.lightGrey}`,
  display: 'flex',
  height: 'auto',
  minHeight: '65px',
  width: '100%',
  [theme.breakpoints.down('500')]: {
    flexWrap: 'wrap'
  }
}));

/**
 * @param status
 * @private
 */
function _getStatusColor(status) {
  let color = colors.skyBlue;
  if (status.toUpperCase() === 'UNDER REVIEW') {
    color = '#FFA500';
  }
  if (status.toUpperCase() === 'APPROVED') {
    color = colors.brandGreen;
  }
  if (status.toUpperCase() === 'UNDER REVISION') {
    color = '#EED401';
  }
  return color;
}

/**
 * @param amendments
 * @param isMasterSite
 * @param whitelabel
 * @returns {JSX.Element}
 * @constructor
 */
const AmendmentList = ({
  amendments,
  isMasterSite,
  whitelabel
}) => {
  const linkPrefix = isMasterSite ? '/accounts' : '/advisor/account';
  const styles = {
    cardBlockAvatar: {
      display: 'inline',
      height: '100%',
      paddingRight: '20px',
      width: '60px'
    },
    cardBlockLeftBody: {
      display: 'inline',
      height: '100%'
    }
  };
  return /*#__PURE__*/React.createElement("div", null, amendments.length === 0 && /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true
  }, i18n.t(tokens.labels.amendments.accountHasNoAmendments)), amendments.map((amendment, i) => {
    const statusColor = _getStatusColor(amendment.status);
    return /*#__PURE__*/React.createElement(Link, {
      key: amendment.amendmentID,
      to: `${linkPrefix}/${amendment.accountID}/amendments/${amendment.amendmentID}`,
      style: {
        textDecoration: 'none'
      }
    }, /*#__PURE__*/React.createElement(CardBlock, null, /*#__PURE__*/React.createElement(CardBlockTop, null, /*#__PURE__*/React.createElement(CardBlockLeft, null, /*#__PURE__*/React.createElement("div", {
      style: styles.cardBlockAvatar
    }, /*#__PURE__*/React.createElement(Avatar, {
      name: `${i18n.t(tokens.labels.amendments.amendment)} ${i + 1}`,
      size: "50",
      textSizeRatio: 2.2,
      round: true,
      fgColor: whitelabel.primaryColor || colors.skyBlue,
      color: whitelabel.lightColor || colors.lightBlue
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.cardBlockLeftBody
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      display: "block"
    }, `${i18n.t(tokens.labels.amendments.amendment)} ${i + 1}`), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "inline"
    }, amendment.amendmentID))), /*#__PURE__*/React.createElement(CardBlockRight, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      margin: "0 8px 0 0",
      color: statusColor
    }, "\u2022"), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      color: colors.darkGrey
    }, localizationMaps.fromEnglish("amendmentStatuses", amendment.status.charAt(0).toUpperCase() + amendment.status.slice(1)))), /*#__PURE__*/React.createElement(Text, {
      color: colors.darkGrey,
      align: "right",
      small: true,
      display: "block"
    }, `${i18n.t(tokens.labels.amendments.agent)}: ${amendment.agent}`))), /*#__PURE__*/React.createElement(CardBlockBottom, null, /*#__PURE__*/React.createElement(CardBlockLeft, null, /*#__PURE__*/React.createElement(Text, {
      color: colors.darkGrey,
      tiny: true,
      display: "inline"
    }, `${i18n.t(tokens.labels.amendments.updated)}: ${dates.getUTC(amendment.dateUpdated, 'lll', i18n.locale)}`)), /*#__PURE__*/React.createElement(CardBlockRight, null, /*#__PURE__*/React.createElement(Text, {
      color: colors.darkGrey,
      tiny: true,
      display: "inline"
    }, `${i18n.t(tokens.labels.amendments.effective)}: ${dates.getUTC(amendment.effectiveDate, 'll', i18n.locale)}`)))));
  }));
};
export default AmendmentList;